import {
  NgModule
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  FormsModule
} from '@angular/forms';

import {
  NgxMaskModule,
  IConfig
} from 'ngx-mask';

const maskConfig: (
  Partial<IConfig>
) = {
  validation: false
};

import {
  LabelInlineEditComponent
} from './label-inline-edit.component';

@NgModule({
  declarations: [
    LabelInlineEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxMaskModule
      .forRoot(
        maskConfig
      )
  ],
  exports: [
    LabelInlineEditComponent
  ],
  providers: []
})
export class LabelInlineEditModule {}